// @flow
import React, {Component} from 'react'
import {connect} from 'react-redux'
import moment from 'moment'
import {Row, Col, Tabs, Select, Input, Drawer, Button, Table, message, InputNumber, DatePicker, Spin, Icon, TreeSelect} from 'antd'
import ApiService from '../../actions/apiService'
import { TradeBoxDiv } from '../ChartDashboard/style'
import {AutoComplete} from 'antd'
import {getPositionsData} from '../../utils/tradeTransactions';
import { getMarketPrices } from '../../actions/portfolios'
import {
  numberFormatter,
  isJson,
  tradeTransHeaders,
  transactionsTreeData,
  positionsTreeData,
  tradePositionsHeaders
} from '../../utils/common'
import {TradeCalculation, TradeCalculation2, GetOptionSymbolNew} from '../../utils/TradeCalculations'
import OptionBook from '../option-book'

const TabPane = Tabs.TabPane
const {TextArea} = Input;
const Option = Select.Option;

const tradeType = {
  0: 'Call',
  1: 'Put'
};

class PositionOverView extends Component {
  
  state = {
    selectedTab: '1',
    isDrawer: false,
    tradeId: this.props.tradeId,
    strategyList: [],
    marketTypeList: [],
    followUpList: [],
    reasonForExitList: [],
    tradeSourceList: [],
    Transactions: [],
    selectedTranHeader: tradeTransHeaders(this.props.hasWriteAccess),
    selectedPositionHeader: tradePositionsHeaders(this.props.hasWriteAccess),
    tranObj: {},
    performanceData: {},
    Tags: [],
    tradeName: '',
    tradeData: this.props.tradeData,
    Description: '',
    Strategy: '',
    TradeSource: '',
    MarketCondition: '',
    FollowUp: '',
    TradeTarget: '',
    TradeRisk: '',
    ReasonForExit: '',
    ExtraNotes: '',
    newSymbol: ''
  }
  
  async componentWillMount() {
    const {account} = this.props;
    const { tradeId, tradeData } = this.state;
    try {
      if (tradeId !== 'new' && tradeData) {
          const tradePrices = await this.getPrices(tradeData.transactions) || {};
          const Transactions = tradeData.transactions.map(t => {
            let marketPrice = null;
            let underlyingPrice = null;
            if (tradePrices[t.symbol]) {
              marketPrice = (((tradePrices[t.symbol].ask || 0) + (tradePrices[t.symbol].bid || 0)) / 2);
              underlyingPrice = tradePrices[t.symbol].underlyingPrice;
            }
            return {
              Expiration: t.expiration ? moment(t.expiration).format('YYYY-MM-DD') : '',
              Price: t.price,
              Action: t.action ? t.action.toLowerCase() : '',
              Strike: t.strike,
              Quantity: t.quantity,
              TransactionGroup: t.transactionGroup,
              Commission: t.commission || 0,
              TradeDate: t.tradeDate ? moment(t.tradeDate).format('YYYY-MM-DD') : null,
              Underlying: t.underlying,
              AssetType: t.assetType === 'Call' ? '0' : '1',
              UnderlyingPrice: underlyingPrice || t.price,
              Mark: marketPrice || t.mark,
              Multiplier: t.multipliper || 100,
              Symbol: t.symbol
            }
          });
          const [positions, transactions] = this.getPositions(Transactions);
          const gainLoss = this.getTradeCalculation(Transactions) || {};
          let performanceData = {};
          try {
            performanceData = TradeCalculation2(positions, transactions) || {};
          } catch (err) {
          }
          this.setState({
            tranObj: null,
            Transactions,
            editIndex: null,
            positions,
            gainLoss,
            performanceData,
            isLoading: false,
            tradeName: tradeData.name,
            strategy: tradeData.strategy,
            margin: tradeData.margin,
            openDate: tradeData.openDate,
          });
      }
    } catch(err) {
    }
    this.getData(account);
  }
  
  getPrices = async (transactions) => {
    try {
      if (transactions) {
        const symbols = transactions.map(x => x.symbol).filter(x => x);
        const uniqSymbols = []
        symbols.forEach(x => {
            if (!uniqSymbols.find(y => y.s === x)) {
              uniqSymbols.push({s:x, d: moment().format('YYYY-MM-DD')});
            }
          }
        );
        if (uniqSymbols.length) {
          const marketPriceRes = await getMarketPrices(uniqSymbols);
          if (marketPriceRes && marketPriceRes.data && marketPriceRes.data.data && marketPriceRes.data.data.securities && marketPriceRes.data.data.securities.options) {
            return marketPriceRes.data.data.securities.options;
          }
        }
      }
      return {};
    } catch(err) {
      return {};
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.account !== nextProps.account) {
      this.getData(nextProps.account);
    }
  }
  
  getData = async (account) => {
    const cacheData = localStorage.getItem('positionListData');
    if (cacheData !== null && isJson(cacheData)) {
      const listData = JSON.parse(cacheData);
      return this.setState({
        ...listData,
      })
    } else {
      const data = {
        Account: account
      };
      const Strategy = await ApiService.postMethod('/account/lists/Strategy', data);
      const MarketType = await ApiService.postMethod('/account/lists/MarketType', data);
      const FollowUp = await ApiService.postMethod('/account/lists/FollowUp', data);
      const ReasonForExit = await ApiService.postMethod('/account/lists/ReasonForExit', data);
      const TradeSource = await ApiService.postMethod('/account/lists/TradeSource', data);
      const listData = {
        strategyList: Strategy || [],
        marketTypeList: MarketType || [],
        followUpList: FollowUp || [],
        reasonForExitList: ReasonForExit || [],
        tradeSourceList: TradeSource || [],
      };
      this.setState({
        ...listData,
      });
      localStorage.setItem('positionListData', JSON.stringify(listData));
    }
  }
  
  onDrawerOpen = () => {
    this.setState({
      isDrawer: true,
    })
  }
  
  onDrawerClose = () => {
    this.setState({
      isDrawer: false,
    })
  }
  
  onChange = (name, value) => {
    this.setState({
      [name]: value,
    })
  }
  
  onInputChange= (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }
  
  onChangeTransactionValues = (name, value) => {
    const {tranObj} = this.state;
    this.setState({
      tranObj: {
        ...tranObj,
        [name]: value
      }
    })
  }
  
  onSave = () => {
    const {tranObj, Transactions, editIndex, openDate, tradeName} = this.state;
    Transactions[editIndex] = tranObj;
    Transactions[editIndex].Symbol = GetOptionSymbolNew(tranObj.Underlying, tranObj.Strike, tranObj.AssetType, tranObj.Expiration, tranObj.Multiplier);
    const [positions, transactions] = this.getPositions(Transactions);
    const gainLoss = this.getTradeCalculation(Transactions) || {};
    let performanceData = {};
    try {
      performanceData = TradeCalculation2(positions, transactions) || {};
    } catch(err) {}
    this.setState({
      tranObj: null, Transactions, editIndex: null, positions, gainLoss, performanceData
    });
    this.props.setCurrentTrade({
      transactions: Transactions,
      openDate,
      tradeName
    });
  }
  
  onEdit = (index) => {
    let {tranObj, Transactions} = this.state;
    tranObj = Transactions[index];
    this.setState({
      tranObj, editIndex: index
    });
  }
  
  onCancel = () => {
    this.setState({
      tranObj: null, editIndex: null
    });
  }
  
  onDelete = (editIndex) => {
    const {Transactions, tradeName, openDate} = this.state;
    const newTransactions = Transactions.filter((x, i) => i !== editIndex);
    const [positions, transactions] = this.getPositions(newTransactions);
    const gainLoss = this.getTradeCalculation(newTransactions) || {};
    let performanceData = {};
    try {
      performanceData = TradeCalculation2(positions, transactions) || {};
    } catch(err) {}
    this.setState({
      tranObj: null, Transactions: newTransactions, editIndex: null, positions, gainLoss, performanceData
    });
    this.props.setCurrentTrade({
      transactions: Transactions,
      openDate,
      tradeName
    });
  }
  
  onAddNew = () => {
    const {Transactions, editIndex} = this.state
    if (editIndex) {
      return;
    }
    const index = Transactions.length;
    const tranObj = {
      TradeDate: null,
      Action: '',
      Quantity: '',
      Underlying: '',
      Expiration: '',
      Strike: '',
      AssetType: '',
      Price: '',
      Commission: '',
      TransactionGroup: '',
      Mark: '',
      Multiplier: 100,
      UnderlyingPrice: ''
    }
    Transactions.push(tranObj)
    this.setState({
      Transactions,
      editIndex: index,
      tranObj: tranObj,
    })
  }
  
  getPositions = (Transactions) => {
    
    const transactions = Transactions.filter(x => x.Price && x.Expiration).map(t => {
      return {
        Qty: parseInt(t.Quantity),
        Multiplier: parseFloat(t.Multiplier),
        OpenPrice: parseFloat(t.Price),
        TradePrice: parseFloat(t.Price),
        StockSymbol: t.Underlying,
        OptionSymbol: t.Symbol || t.Underlying,
        Mark: parseFloat(t.Mark),
        ExpirationDate: new Date(t.Expiration),
        UnderlyingPrice: parseFloat(t.UnderlyingPrice),
        Strike: parseFloat(t.Strike),
        TradeType: parseInt(t.AssetType),
        TradeDate: new Date(t.TradeDate),
        TradeSide: t.Action,
        Commission: parseFloat(t.Commission),
      }
    });
    const positions = getPositionsData(transactions);
    return [positions.map(p => {
      return {
        ...p,
        OpenDate: p.OpenDate ? moment(p.OpenDate).format('YYYY-MM-DD') : null,
        CloseDate: p.CloseDate ? moment(p.CloseDate).format('YYYY-MM-DD') : null,
        isClosed: !!p.CloseDate,
        Qty: p.Quantity,
        TradeType: tradeType[p.TradeType],
        Instrument: p.InstrumentDescription,
      }
    }), transactions]
  }
  
  onTradeNameSave = async () => {
    const {tradeName} = this.state;
    const data = {
      Name: this.state.tradeName,
    }
    // const response = await ApiService.postMethod('/portfolio/addtrade', data);
  }
  
  getTradeCalculation = (Transactions) => {
    const transactions = Transactions.filter(x => x.Underlying && x.Price && x.Expiration).map(t => {
      return {
        Qty: parseInt(t.Quantity),
        Multiplier: parseFloat(t.Multiplier),
        OpenPrice: parseFloat(t.Price),
        TradePrice: parseFloat(t.Price),
        StockSymbol: t.Underlying,
        OptionSymbol: t.Symbol || t.Underlying,
        Mark: parseFloat(t.Mark),
        ExpirationDate: new Date(t.Expiration),
        UnderlyingPrice: parseFloat(t.UnderlyingPrice),
        Strike: parseFloat(t.Strike),
        TradeType: parseInt(t.AssetType),
        TradeDate: new Date(t.TradeDate),
        TradeSide: t.Action
      }
    });
    return TradeCalculation(transactions);
  }
  
  onSaveTrade = async () => {
    let data = {};
    if (this.props.tradeId !== 'new') {
      data.TradeID = this.props.tradeId;
    }
    const {Description, Strategy, Tags, TradeSource, MarketCondition, FollowUp, TradeTarget, ReasonForExit, ExtraNotes, Transactions, TradeRisk} = this.state;
    const transactions = Transactions.map(t=> {
      return {
        ...t,
        AssetType: t.AssetType === '0' ? 'Call' : 'Put'
      }
    })

    data = {
      ...data,
      Description,
      Strategy,
      Tags,
      TradeSource,
      MarketCondition,
      FollowUp,
      TradeTarget,
      TradeRisk,
      ReasonForExit,
      ExtraNotes,
      Transactions: transactions,
      Name: this.props.tradeName,
    }
  
    
    
    const response = await ApiService.postMethod('/account/addupdatetrade', data);
    if (response !== null) {
      message.success('Trade saved successfully');
    } else {
      message.error('Error while saving trade');
    }
  }
  
  handleTagChange = (Tags) => {
    this.setState({
      Tags,
    })
  }
  
  getTransactionsColumns = () => {
    const { editIndex, tranObj, selectedTranHeader } = this.state;
    let columns = []

    if(selectedTranHeader.includes('TradeDate')) {
      columns.push({
        title: 'Date',
        dataIndex: 'TradeDate',
        key: 'TradeDate',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <DatePicker showTime format={`MM/DD/YYYY, h:mm:ss a`} value={tranObj.TradeDate ? moment(tranObj.TradeDate) : ''}
                               onChange={(e, string) => this.onChangeTransactionValues('TradeDate', string)}/>;
          } else {
            return text && moment(text).format("MM/DD/YYYY, h:mm:ss a")
          }
        }
      })
    }
    if(selectedTranHeader.includes('Action')) {
      columns.push({
        title: 'Action',
        dataIndex: 'Action',
        key: 'Action',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <Select value={tranObj.Action} onChange={(e) => this.onChangeTransactionValues('Action', e)}
                           style={{width: 100}}>
              <Option value="buy">Buy</Option>
              <Option value="sell">Sell</Option>
            </Select>
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('AssetType')) {
      columns.push({
        title: 'Type',
        dataIndex: 'AssetType',
        key: 'AssetType',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <Select value={tranObj.AssetType }
                           onChange={(e) => this.onChangeTransactionValues('AssetType', e, index)} style={{width: 60}}>
              <Option value="0">Call</Option>
              <Option value="1">Put</Option>
            </Select>
          } else {
            return text ? tradeType[text] : ''
          }
        }
      })
    }
    if(selectedTranHeader.includes('Underlying')) {
      columns.push({
        title: 'Underlying',
        dataIndex: 'Underlying',
        key: 'Underlying',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <Input value={tranObj.Underlying}
                          onChange={(e) => this.onChangeTransactionValues('Underlying', e.target.value, index)}
                          style={{width: 100}}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('Quantity')) {
      columns.push({
        title: 'Qty',
        dataIndex: 'Quantity',
        key: 'Quantity',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <InputNumber value={tranObj.Quantity}
                                onChange={(e) => this.onChangeTransactionValues('Quantity', e)}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('Expiration')) {
      columns.push({
        title: 'Exp Date',
        dataIndex: 'Expiration',
        key: 'Expiration',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <DatePicker showTime format={`MM/DD/YYYY, h:mm:ss a`} value={tranObj.Expiration ? moment(tranObj.Expiration) : ''}
                               onChange={(e, string) => this.onChangeTransactionValues('Expiration', string)}/>;
          } else {
            return text && moment(text).format("MM/DD/YYYY, h:mm:ss a")
          }
        }
      })
    }
    if(selectedTranHeader.includes('Strike')) {
      columns.push({
        title: 'Strike',
        dataIndex: 'Strike',
        key: 'Strike',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <InputNumber value={tranObj.Strike} onChange={(e) => this.onChangeTransactionValues('Strike', e)}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('Price')) {
      columns.push({
        title: 'Price',
        dataIndex: 'Price',
        key: 'Price',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <InputNumber value={tranObj.Price} onChange={(e) => this.onChangeTransactionValues('Price', e)}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('Commission')) {
      columns.push({
        title: 'Commission',
        dataIndex: 'Commission',
        key: 'Commission',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <InputNumber value={tranObj.Commission}
                                onChange={(e) => this.onChangeTransactionValues('Commission', e)}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('Multiplier')) {
      columns.push({
        title: 'Multiplier',
        dataIndex: 'Multiplier',
        key: 'Multiplier',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <InputNumber value={tranObj.Multiplier}
                                onChange={(e) => this.onChangeTransactionValues('Multiplier', e)}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('UnderlyingPrice')) {
      columns.push({
        title: 'UnderlyingPrice',
        dataIndex: 'UnderlyingPrice',
        key: 'UnderlyingPrice',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <InputNumber value={tranObj.UnderlyingPrice}
                                onChange={(e) => this.onChangeTransactionValues('UnderlyingPrice', e)}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('Mark')) {
      columns.push({
        title: 'Mark',
        dataIndex: 'Mark',
        key: 'Mark',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <InputNumber value={tranObj.Mark} onChange={(e) => this.onChangeTransactionValues('Mark', e)}/>;
          } else {
            return text
          }
        }
      })
    }
    if(selectedTranHeader.includes('TransactionGroup')) {
      columns.push({
        title: 'Group',
        dataIndex: 'TransactionGroup',
        key: 'TransactionGroup',
        render: (text, record, index) => {
          if (editIndex === index) {
            return <Input value={tranObj.TransactionGroup}
                          onChange={(e) => this.onChangeTransactionValues('TransactionGroup', e.target.value)}
                          style={{width: 100}}/>;
          } else {
            return text
          }
        }
      })
    }
    
    if (selectedTranHeader.includes('Actions')) {
      columns.push({
        title: 'Actions',
        width: 100,
        render: (text, record, index) => {
          if (editIndex === index) {
            return <span> <Icon type="save" className="dx-g-bs4-cursor-pointer" onClick={() => this.onSave(index)}/>
            <Icon type="close" className="dx-g-bs4-cursor-pointer dx-g-bs4-filter-selector-item-text" onClick={() => this.onCancel(index)}/></span>
          } else {
            return <span> <Icon type="edit" className="dx-g-bs4-cursor-pointer" onClick={() => this.onEdit(index)} />
            <Icon type="delete" className="dx-g-bs4-cursor-pointer dx-g-bs4-filter-selector-item-text" onClick={() => this.onDelete(index)} /></span>
          }
        }
      })
    }
    return columns;
  }

  getPositionColumns = () => {
    const { selectedPositionHeader } = this.state;
    let columns = []

    if(selectedPositionHeader.includes('Instrument')) {
      columns.push({
        name: 'Instrument',
        title: 'Instrument',
        dataIndex: 'Instrument'
      })
    }
    if(selectedPositionHeader.includes('OpenDate')) {
      columns.push({
        name: 'OpenDate',
        title: 'Open Date',
        dataIndex: 'OpenDate'
      })
    }
    if(selectedPositionHeader.includes('CloseDate')) {
      columns.push({
        name: 'CloseDate',
        title: 'Close Date',
        dataIndex: 'CloseDate'
      })
    }
    if(selectedPositionHeader.includes('Quantity')) {
      columns.push({
        name: 'Quantity',
        title: 'Qty',
        dataIndex: 'Quantity'
      })
    }
    if(selectedPositionHeader.includes('AveragePrice')) {
      columns.push({
        name: 'AveragePrice',
        title: 'Avg Price',
        dataIndex: 'AveragePrice',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('Price')) {
      columns.push({
        name: 'Price',
        title: 'Price',
        dataIndex: 'Price',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('Delta')) {
      columns.push({
        name: 'Delta',
        title: 'Delta',
        dataIndex: 'Delta',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('Gamma')) {
      columns.push({
        name: 'Gamma',
        title: 'Gamma',
        dataIndex: 'Gamma',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('Theta')) {
      columns.push({
        name: 'Theta',
        title: 'Theta',
        dataIndex: 'Theta',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('Vega')) {
      columns.push({
        name: 'Vega',
        title: 'Vega',
        dataIndex: 'Vega',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('ImpliedVolatility')) {
      columns.push({
        name: 'ImpliedVolatility',
        title: 'IV',
        dataIndex: 'ImpliedVolatility',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('DaysToExpire')) {
      columns.push({
        name: 'DaysToExpire',
        title: 'Days to Expire',
        dataIndex: 'DaysToExpire',
        render: (text) => {
          let value = ''
          if(text && !isNaN(text)) {
            value = parseFloat(text).toFixed(2)
            if(value <= 0) {
              value = "Expired"
            }
          }
          return value
        }
      })
    }
    if(selectedPositionHeader.includes('PlOpen')) {
      columns.push({
        name: 'PlOpen',
        title: 'P/L Open',
        dataIndex: 'PlOpen',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    if(selectedPositionHeader.includes('PlClosed')) {
      columns.push({
        name: 'PlClosed',
        title: 'P/L Closed',
        dataIndex: 'PlClosed',
        render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}
      })
    }
    return columns;
  }
  
  onAddOptionChain = () => {
    this.setState({
      optionChainView: !this.state.optionChainView,
    })
  }
  
  loadOptionChain = () => {
    if (!this.state.newSymbol) {
      return alert('Please enter name of symbol!')
    } else {
      this.setState({
        optionChain: false
      }, () => {
        this.setState({
          optionChain: true
        })
      })
    }
  }
  
  onCopyTransactions = (ts = []) => {
   try {
      let {Transactions} = this.state;
      const newTransactions = ts.map(t => {
        return {
          TradeDate: t.tradeDate,
          Action: t.side || 'buy',
          Symbol: t.symbol || '',
          Quantity: t.quantity || '',
          Underlying: t.underlyingSymbol || '',
          UnderlyingPrice: (t.underlyingPrice && parseFloat(t.underlyingPrice).toFixed(2)) || '',
          Expiration: t.expiration || '',
          Strike: t.strike || '',
          AssetType: t.assetType === 'Call' ? '0' : '1',
          Price: t.price || '',
          Commission: '',
          TransactionGroup: '',
          Mark: t.mark || '',
          Multiplier: t.multiplier || 100,
        }
      });
      Transactions = [...Transactions, ...newTransactions];
      const [positions, transactions] = this.getPositions(Transactions);
      const gainLoss = this.getTradeCalculation(Transactions) || {};
      let performanceData = {};
      try {
        performanceData = TradeCalculation2(positions, transactions) || {};
      } catch (err) {
      }
      this.setState({
        tranObj: null, Transactions, editIndex: null, positions, gainLoss, performanceData, optionChain: false
      });
      this.props.setCurrentTrade({
        transactions: Transactions,
      });
    } catch(err) {}
  }

  onTransHeaderChanges = value => {
    this.setState({ selectedTranHeader: value });
  };

  onPositionsHeaderChanges = value => {
    this.setState({ selectedPositionHeader: value });
  };
  
  render() {
    const {strategyList, marketTypeList, followUpList, tradeSourceList, TradeSource, FollowUp, Strategy, Transactions, MarketCondition,
      TradeRisk, positions=[], isLoading, ReasonForExit, TradeTarget, ExtraNotes, Tags, optionChain, newSymbol = '', optionChainView} = this.state;
    const { tradeName } = this.props;
    const strategies = strategyList.map(x => x.value);
    const markets = marketTypeList.map(x => x.value);
    const followUps = followUpList.map(x => x.value);
    const tradeSources = tradeSourceList.map(x => x.value);
    const reasonForExitSources = ['Call Ratio Back Spread', 'All'];
    const {performanceData: {TotalProfitLoss, OpenPL, ClosedPL, MarkTradePrice, MaxLoss, MaxGain, DaysInTrade, Commission, CurrentPrice}} = this.state;
    const {hasWriteAccess} = this.props;
    let uint = number =>  Math.sqrt(Math.pow(number, 2));
    const transactionsTreeProps = {
      treeData: transactionsTreeData(hasWriteAccess),
      value: this.state.selectedTranHeader,
      onChange: this.onTransHeaderChanges,
      treeCheckable: true,
      placeholder: 'Please select',
      style: {
        width: '50%',
      },
    };
    const positionsTreeProps = {
      treeData: positionsTreeData(hasWriteAccess),
      value: this.state.selectedPositionHeader,
      onChange: this.onPositionsHeaderChanges,
      treeCheckable: true,
      placeholder: 'Please select',
      style: {
        width: '50%',
      },
    };
    return (
      <div>
        {
          isLoading ?
            <div style={{padding: 100, textAlign: 'center'}}><Spin size="lg" /></div> :
              <Row>
                <Col span={24}>
                  <Row>
                    <Col md={9} xl={8}>
                      <TradeBoxDiv className="trade-box">
                        <h3>Profit Loss</h3>
                        <small>{TotalProfitLoss === MaxLoss ? 100 : (MaxLoss !== 0 ? ((((TotalProfitLoss || 0) / (uint(MaxLoss) )) * 100).toFixed(2)) : 0)}%</small>
                        <div>
                          <b>${numberFormatter(TotalProfitLoss || 0)}</b>
                          <span className={ parseFloat(OpenPL || 0) >= 0 ? 'green' : 'red'}>${numberFormatter(OpenPL || 0)} O</span>
                          <span className={ parseFloat(ClosedPL || 0) >= 0 ? 'green' : 'red'}>${numberFormatter(ClosedPL || 0)} C</span>
                        </div>
                      </TradeBoxDiv>
                    </Col>
                    <Col md={5} xl={5}>
                      <TradeBoxDiv className="trade-box">
                        <h3>Current Price</h3>
                        <small>{uint(DaysInTrade || 0)} days</small>
                        <div>
                          <b>${numberFormatter(MarkTradePrice || 0)}</b>
                          <span>${numberFormatter(CurrentPrice || 0)}</span>
                        </div>
                      </TradeBoxDiv>
                    </Col>
                    <Col md={5} xl={6}>
                      <TradeBoxDiv className="trade-box">
                        <h3>Max Loss/ Max Profit</h3>
                        <div>
                          <b>{numberFormatter(MaxLoss || 0)} / {numberFormatter(MaxGain || 0)}</b>
                        </div>
                      </TradeBoxDiv>
                    </Col>
                    <Col md={5} xl={5}>
                      <TradeBoxDiv className="trade-box">
                        <h3>Commission</h3>
                        <div>
                          <b>${numberFormatter(Commission || 0)}</b>
                        </div>
                      </TradeBoxDiv>
                    </Col>
                  </Row>
                  {
                    hasWriteAccess &&
                    <Tabs className="tabs">
                      <TabPane tab='Main' key='1'>
                        <div className="section">
                          <Row>
                            <Col span={24}>
                              <div>Strategy:</div>
                              <div>
                                <AutoComplete
                                  dataSource={strategies.filter(x => x && x.toLowerCase().includes(Strategy || ''))}
                                  placeholder='Strategy'
                                  value={Strategy}
                                  style={{width: '100%'}}
                                  onChange={(val) => this.onChange('Strategy', val)}
                                >
                                  <Input style={{width: '100%'}} />
                                </AutoComplete>
                              </div>
                            </Col>
                          </Row>
                          {/*<Row>*/}
                          {/*<Col span={24}>*/}
                          {/*<div>Margin / Debit:</div>*/}
                          {/*<div><Input name="Margin" value={Margin} onChange={this.onInputChange} /></div>*/}
                          {/*</Col>*/}
                          {/*</Row>*/}
                          <Row>
                            <Col span={24}>
                              <div>Tags:</div>
                              <div>
                                <Select
                                  mode="tags"
                                  placeholder="Type in your Tag and Press Enter"
                                  defaultValue={Tags}
                                  onChange={this.handleTagChange}
                                  style={{ width: '100%' }}
                                >
                                </Select>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
  
                      <TabPane tab='Trade Plan' key='2'>
                        <div className="section trade-plan">
                          <Row>
                            <Col span={6}>
                              <div>Trade Source:</div>
                            </Col>
                            <Col span={18}>
                              <AutoComplete
                                dataSource={tradeSources.filter(x => x && x.toLowerCase().includes(TradeSource || ''))}
                                value={TradeSource}
                                style={{width: '100%'}}
                                onChange={(val) => this.onChange('TradeSource', val)}
                                placeholder='Trade Source'
                              >
                                <Input style={{width: '100%'}}/>
                              </AutoComplete>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <div>Market Condition:</div>
                            </Col>
                            <Col span={18}>
                              <AutoComplete
                                dataSource={markets.filter(x => x && x.toLowerCase().includes(MarketCondition || ''))}
                                value={MarketCondition}
                                style={{width: '100%'}}
                                onChange={(val) => this.onChange('MarketCondition', val)}
                                placeholder='Market Condition'
                              >
                                <Input style={{width: '100%'}}/>
                              </AutoComplete>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <div>Follow Up:</div>
                            </Col>
                            <Col span={18}>
                              <AutoComplete
                                dataSource={followUps.filter(x => x && x.toLowerCase().includes(FollowUp || ''))}
                                value={FollowUp}
                                style={{width: '100%'}}
                                onChange={(val) => this.onChange('FollowUp', val)}
                                placeholder='FollowUp'
                              >
                                <Input style={{width: '100%'}}/>
                              </AutoComplete>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <div>Trade Target:</div>
                            </Col>
                            <Col span={18}>
                              <Input placeHolder="Trade Target" name="TradeTarget" value={TradeTarget} onChange={this.onInputChange}/>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <div>Trade Risk:</div>
                            </Col>
                            <Col span={18}>
                              <Input placeHolder="Trade Risk" value={TradeRisk} name="TradeRisk" onChange={this.onInputChange}/>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <div>Max Loss:</div>
                            </Col>
                            <Col span={18}>
                              <Input/>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <div>Max Gain:</div>
                            </Col>
                            <Col span={18}>
                              <Input/>
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
  
                      <TabPane tab='Trade Outcome' key='3'>
                        <div className="section trade-plan">
                          <Row>
                            <Col span={6}>
                              <div>Reason for Exit:</div>
                            </Col>
                            <Col span={18}>
                              <AutoComplete
                                dataSource={reasonForExitSources}
                                value={ReasonForExit}
                                style={{width: '100%'}}
                                onChange={(val) => this.onChange('ReasonForExit', val)}
                                placeholder='Reason For Exit'
                              >
                                <Input style={{width: '100%'}}/>
                              </AutoComplete>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <div>Extra Notes:</div>
                            </Col>
                            <Col span={18}>
                              <TextArea onChange={this.onInputChange} value={ExtraNotes} name="ExtraNotes" rows={4}/>
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
  
                      <TabPane tab='Alerts' key='4'>
                      </TabPane>
  
                      <TabPane tab='TOS Paste' key='5'>
                      </TabPane>
                    </Tabs>
                  }
                  <h4 className="title" style={{display: "flex"}}>
                    Positions
                    <div style={{width: '100%', textAlign: 'right'}}>
                      <TreeSelect {...positionsTreeProps} />
                    </div>
                  </h4>
                  <Table
                    columns={this.getPositionColumns()}
                    size={'small'}
                    dataSource={positions}
                    pagination={false}
                  />
                  <h4 className="title" style={{display: "flex"}}>
                    Transactions
                    <div style={{width: '100%', textAlign: 'right'}}>
                      <TreeSelect {...transactionsTreeProps} />
                    </div>
                  </h4>
                  {
                    hasWriteAccess &&
                    <div style={{marginBottom: 10}}>
                      <Button icon="plus" onClick={this.onAddNew}>New</Button>
                      <Button icon="plus" style={{marginLeft: 10}} onClick={this.onAddOptionChain}>{ optionChainView ? 'Close Option Chain' : 'Option Chain'}</Button>
                      {optionChainView && <Input placeHolder="symbol" value={newSymbol} name="newSymbol" onChange={this.onInputChange}/> }
                      {optionChainView && <Button onClick={this.loadOptionChain}>Load Option Chain</Button> }
                    </div>
                  }
                  <Table
                    columns={this.getTransactionsColumns()}
                    size={'small'}
                    dataSource={Transactions}
                    pagination={false}
                    scroll={{ x: true }}
                  />
                </Col>
                {
                  optionChain && newSymbol &&
                  <Col sm={24}>
                    <OptionBook symbol={newSymbol} isNewTrade={true} onCopyTransactions={this.onCopyTransactions}  />
                  </Col>
                }
                {
                  hasWriteAccess &&
                  <Col sm={24}>
                    <Button type="primary" onClick={this.onSaveTrade} style={{margin: '20px 0'}}>Save Trade
                      Data</Button>
                  </Col>
                }
              </Row>
        }
        <Drawer
          title="Basic Drawer"
          placement="right"
          closable={true}
          onClose={this.onDrawerClose}
          visible={this.state.isDrawer}
        >
          <p>Some contents...</p>
          <p>Some contents...</p>
          <p>Some contents...</p>
        </Drawer>
      </div>
    
    )
  }
}

const mapStateToProps = (state: Object) => ({
  account: state.account.selectedAccount
})

export default connect(mapStateToProps, null)(PositionOverView)



// WEBPACK FOOTER //
// ./src/components/own-positions/PositionOverView.js